import React, { Component } from 'react';
import ImageIndex from '../components/image_index';
import classnames from 'classnames';
import ReactVisibilitySensor from 'react-visibility-sensor';
import { connect } from 'react-redux';
import { selectImage } from '../actions/index';
import { bindActionCreators } from 'redux';

class PanelImage extends Component {
  constructor(props) {
    super(props);
    this.state = { url: null, imageLoaded: false };
    this.index = ImageIndex();
  }
  onImageLoad() {
    this.setState({ imageLoaded: true });
  }
  onImageVisible(isVisible) {
    if (isVisible) {
      this.setState({ url: this.props.imageUrl });
    }
  }
  render() {
    return (
      <ReactVisibilitySensor onChange={this.onImageVisible.bind(this)} partialVisibility={true}>
        <li
          className={classnames(
            'panel-image h-100p d-ib',
            { 'bd-lightgray': !this.state.imageLoaded },
            { 'bd-n': this.state.imageLoaded },
            { landscape: this.props.imageSize == 'landscape' },
            { portrait: this.props.imageSize == 'portrait' }
          )}>
          <img
            className={classnames(
              'w-100p h-100p ofit-cover opos-center cur-p',
              { 'pe-none op-0': !this.state.imageLoaded },
              { 'pe-auto op-1': this.state.imageLoaded }
            )}
            src={this.state.url}
            onLoad={this.onImageLoad.bind(this)}
            onClick={() => this.props.selectImage(this.index)}
          />
        </li>
      </ReactVisibilitySensor>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ selectImage: selectImage }, dispatch);
}

export default connect(null, mapDispatchToProps)(PanelImage);



// WEBPACK FOOTER //
// ./src/containers/panel_image.js